// TODO set transform origin prop of all elements on index change

import { resolve } from 'promiscuous/dist/promiscuous-browser-shim-full';
import WidgetBase from '../widget.base';
import FormFieldComponent from './fields/_FormFieldComponent';
import FormFieldHelper from './FormFieldHelper';
import { getTrackingData, pushTrackingData } from '../../lib/dataLayer';

export default class FormComponent extends WidgetBase {
    static selector = '[data-ww-form]';
    formEl;
    formKey;
    pageId;
    fieldMap;
    tokenHeaderName;
    tokenValue;
    successContent;
    errorContent;

    constructor(el) {
        super(el);

        if (!this.el) {
            return;
        }

        this.successContent = this.el.querySelector(".formulate-success-content");
        this.errorContent = this.el.querySelector(".formulate-error-content");

        this.fieldMap = [];

        this.formKey = this.el.dataset.formKey;
        this.tokenHeaderName = this.el.dataset.tokenHeaderName;
        this.tokenValue = this.el.dataset.tokenValue;

        this.init(this.el);

        setTimeout(() => {
            this.loaded();
        })
    }

    init(el) {
        const formEl = el.querySelector('form');
        const trackingData = getTrackingData(el);

        this.pageId = formEl.dataset.pageId;

        this.buildFieldMap(formEl);
        this.addSubmitHandler(formEl, trackingData);
    }

    buildFieldMap(formEl) {
        const fieldEls = [...formEl.querySelectorAll('.formulate__field')];

        fieldEls.forEach((el) => {
            const field = FormFieldHelper.getFieldComponent(el);
            if (typeof (field) !== 'undefined') {
                this.fieldMap[field.id] = field;
            }
        });
    };

    addSubmitHandler(formEl, trackingData) {
        formEl.addEventListener('submit', (e) => this.submit(e, trackingData));
    };

    validateForm(formEl) {
        const promises = [];

        Object.entries(this.fieldMap).forEach(([key, value]) => {
            promises.push(value.validate());
        });

        return Promise.all(promises).then((values) => {
            const isValid = values.flat().every(x => x.valid);

            return Promise.resolve(isValid);
        });
    }

    submit(e, trackingData) {
        e.preventDefault();
        const formEl = e.target;
        this.validateForm(formEl)
            .then(async response => {
                if (response) {
                    await this.postForm(formEl, trackingData);
                }
            });
    };

    async postForm(formEl, trackingData) {
        const data = {
            contentKey: this.pageId,
            values: {}
        };

        Object.entries(this.fieldMap).forEach(([key, value]) => {
            data.values[value.getFieldAlias()] = value.getValue();
        });

        const headers = {
            "Content-Type": "application/json",
        };

        headers[this.tokenHeaderName] = this.tokenValue;

        await fetch(`/umbraco/forms/api/v1.0/entries/${this.formKey}`, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(data),
        }).then((response) => {
            if (response.status === 202) {
                this.showSuccess(formEl);
                pushTrackingData(trackingData);
            }
            // Umbraco Forms could return server side validation feedback but that is not currently handled in this version.
            else {
                this.showError(formEl);
            }
        });
    }

    showSuccess(formEl) {
        formEl.parentNode.removeChild(formEl);
        this.errorContent.parentNode.removeChild(this.errorContent);
        this.successContent.classList.remove("formulate-success-content--hidden");
        this.successContent.classList.add("formulate-success-content--visible");
        window.scrollTo(0, 0);
    }

    showError() {
        this.errorContent.classList.remove("formulate-success-content--hidden");
        this.errorContent.classList.add("formulate-success-content--visible");
    }
}